import { render } from "./HeartRate.vue?vue&type=template&id=524502dd&scoped=true&ts=true"
import script from "./HeartRate.vue?vue&type=script&lang=ts"
export * from "./HeartRate.vue?vue&type=script&lang=ts"

import "./HeartRate.vue?vue&type=style&index=0&id=524502dd&scoped=true&lang=less"

import exportComponent from "D:\\project\\mpe-project\\vue-project\\mobile-mpe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524502dd"]])

export default __exports__